import { useCallback, useState, VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextInput } from '../components/Uikit/TextInput';
import { RootState } from '../reducks/store/store';
import { updateUserInfo } from '../reducks/users/operations';
import { getUserInfo } from '../reducks/users/selectors';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { PrimaryButton } from '../components/Uikit/PrimaryButton';
import { PrimaryOutlineButton } from '../components/Uikit/PrimaryOutlineButton';
import { useNavigate } from 'react-router-dom';

const MypageEdit: VFC = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state: RootState) => state);
  const userInfo = getUserInfo(selector);
  const navigate = useNavigate();

  const [firstNameKana, setFirstNameKana] = useState(userInfo.firstNameKana || '');
  const [lastNameKana, setLastNameKana] = useState(userInfo.lastNameKana || '');
  const email = userInfo.email || '';
  const [phone, setPhone] = useState(userInfo.phone || '');
  const [address, setAddress] = useState(userInfo.address || '');
  const [gender, setGender] = useState(userInfo.gender || '');
  const [birthdayYear, setBirthdayYear] = useState(userInfo.birthdayYear || '');
  const [birthdayMonth, setBirthdayMonth] = useState(userInfo.birthdayMonth || '');

  const currentYear = new Date().getFullYear();
  const years = Array.from({length: 120}, (_, i) => currentYear - 119 + i);
  const months = Array.from({length: 12}, (_, i) => 1 + i);

  const inputFirstNameKana = useCallback(
    (e) => {
      setFirstNameKana(e.target.value);
    },
    [setFirstNameKana]
  );
  const inputLastNameKana = useCallback(
    (e) => {
      setLastNameKana(e.target.value);
    },
    [setLastNameKana]
  );
  const inputPhone = useCallback(
    (e) => {
      setPhone(e.target.value);
    },
    [setPhone]
  );
  const inputAddress = useCallback(
    (e) => {
      setAddress(e.target.value);
    },
    [setAddress]
  );
  const inputGender = useCallback(
    (e) => {
      setGender(e.target.value);
    },
    [setGender]
  );
  const inputBirthdayYear = useCallback(
    (e) => {
      setBirthdayYear(e.target.value);
    },
    [setBirthdayYear]
  );
  const inputBirthdayMonth = useCallback(
    (e) => {
      setBirthdayMonth(e.target.value);
    },
    [setBirthdayMonth]
  );

  const saveUserInfo = () => {
    console.log('click!ユーザー情報更新！');
    
    dispatch(updateUserInfo(firstNameKana, lastNameKana, email, phone, address, gender, birthdayYear, birthdayMonth, navigate));
  };

  return (
    <section className='mx-auto my-0 max-w-xl relative py-0 px-4 text-center w-full sm:max-w-5xl'>
      <h1 className='text-pandacco text-2xl mt-0 mx-auto mb-4'>
        アカウント情報の変更
      </h1>
      <div style={{ marginBottom: '20px' }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TextInput
              fullWidth={true}
              label={'姓（カタカナ）'}
              multiline={false}
              required={true}
              rows={1}
              value={lastNameKana}
              type={'text'}
              onChange={inputLastNameKana}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              fullWidth={true}
              label={'名（カタカナ）'}
              multiline={false}
              required={true}
              rows={1}
              value={firstNameKana}
              type={'text'}
              onChange={inputFirstNameKana}
            />
          </Grid>
        </Grid>
        <TextInput
          fullWidth={true}
          label={'電話番号'}
          multiline={false}
          required={true}
          rows={1}
          value={phone}
          type={'text'}
          onChange={inputPhone}
        />
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>生年月日（年）</InputLabel>
              <Select
                value={birthdayYear}
                onChange={inputBirthdayYear}
                onOpen={() => {
                  if (!birthdayYear) {
                    setBirthdayYear(currentYear.toString());
                  }
                }}
              >
                {years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>生年月日（月）</InputLabel>
              <Select
                value={birthdayMonth}
                onChange={inputBirthdayMonth}
              >
                {months.map(month => <MenuItem key={month} value={month}>{month}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <FormControl fullWidth>
          <InputLabel>性別</InputLabel>
          <Select
            value={gender}
            onChange={inputGender}
          >
            <MenuItem value="male">男性</MenuItem>
            <MenuItem value="female">女性</MenuItem>
            <MenuItem value="neither">答えたくない</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>都道府県</InputLabel>
          <Select
            value={address}
            onChange={inputAddress}
          >
            <MenuItem value="北海道">北海道</MenuItem>
          <MenuItem value="青森県">青森県</MenuItem>
          <MenuItem value="岩手県">岩手県</MenuItem>
          <MenuItem value="宮城県">宮城県</MenuItem>
          <MenuItem value="秋田県">秋田県</MenuItem>
          <MenuItem value="山形県">山形県</MenuItem>
          <MenuItem value="福島県">福島県</MenuItem>
          <MenuItem value="茨城県">茨城県</MenuItem>
          <MenuItem value="栃木県">栃木県</MenuItem>
          <MenuItem value="群馬県">群馬県</MenuItem>
          <MenuItem value="埼玉県">埼玉県</MenuItem>
          <MenuItem value="千葉県">千葉県</MenuItem>
          <MenuItem value="東京都">東京都</MenuItem>
          <MenuItem value="神奈川県">神奈川県</MenuItem>
          <MenuItem value="新潟県">新潟県</MenuItem>
          <MenuItem value="富山県">富山県</MenuItem>
          <MenuItem value="石川県">石川県</MenuItem>
          <MenuItem value="福井県">福井県</MenuItem>
          <MenuItem value="山梨県">山梨県</MenuItem>
          <MenuItem value="長野県">長野県</MenuItem>
          <MenuItem value="岐阜県">岐阜県</MenuItem>
          <MenuItem value="静岡県">静岡県</MenuItem>
          <MenuItem value="愛知県">愛知県</MenuItem>
          <MenuItem value="三重県">三重県</MenuItem>
          <MenuItem value="滋賀県">滋賀県</MenuItem>
          <MenuItem value="京都府">京都府</MenuItem>
          <MenuItem value="大阪府">大阪府</MenuItem>
          <MenuItem value="兵庫県">兵庫県</MenuItem>
          <MenuItem value="奈良県">奈良県</MenuItem>
          <MenuItem value="和歌山県">和歌山県</MenuItem>
          <MenuItem value="鳥取県">鳥取県</MenuItem>
          <MenuItem value="島根県">島根県</MenuItem>
          <MenuItem value="岡山県">岡山県</MenuItem>
          <MenuItem value="広島県">広島県</MenuItem>
          <MenuItem value="山口県">山口県</MenuItem>
          <MenuItem value="徳島県">徳島県</MenuItem>
          <MenuItem value="香川県">香川県</MenuItem>
          <MenuItem value="愛媛県">愛媛県</MenuItem>
          <MenuItem value="高知県">高知県</MenuItem>
          <MenuItem value="福岡県">福岡県</MenuItem>
          <MenuItem value="佐賀県">佐賀県</MenuItem>
          <MenuItem value="長崎県">長崎県</MenuItem>
          <MenuItem value="熊本県">熊本県</MenuItem>
          <MenuItem value="大分県">大分県</MenuItem>
          <MenuItem value="宮崎県">宮崎県</MenuItem>
          <MenuItem value="鹿児島県">鹿児島県</MenuItem>
          <MenuItem value="沖縄県">沖縄県</MenuItem>
          </Select>
        </FormControl>
        <p className="text-lg text-gray-600 text-right">
        <span className="text-2xl text-customRed">*</span> は必須項目です
        </p>
      </div>
      <PrimaryButton label={'保存'} onClick={saveUserInfo} />
      <PrimaryOutlineButton label={'キャンセル'} onClick={() =>  navigate('/user/my-page')} />
    </section>
  );
};

export default MypageEdit;
